import 'babel-polyfill';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import './sass/main.scss';
import 'bootstrap-4-grid';
import 'bootstrap-utilities';
import App from './App';

const Root = () => (
    <div className="pagewrap" id="PageWrap">
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </div>
);

ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js